import React from 'react';

interface LoadingOverlayProps {
    message?: string;
}

export default function LoadingOverlay({ message = 'Salvando dados...' }: LoadingOverlayProps) {
    return (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[9999] flex items-center justify-center animate-fade-in">
            <div className="bg-white rounded-xl shadow-2xl p-6 flex flex-col items-center animate-scale-up">
                <div className="w-12 h-12 border-4 border-teal-100 border-t-teal-600 rounded-full animate-spin mb-4"></div>
                <p className="text-gray-700 font-medium text-lg">{message}</p>
            </div>
        </div>
    );
}
